import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { fetchMe } from 'redux/users/actions';
import { updateBillingPlanPaypal, clearUpdateBillingPlanPaypal } from 'redux/billing/actions';

import { PayPalButton } from "react-paypal-button-v2";

import CommonMessage from 'components/common/CommonMessage';
import Button from 'components/elements/buttons/Button';

import './PaypalButton.css';


const PaypalButtonComponent = props => {
  const {
    interval,
    billingPlans,
    fetchMe,
    updateBillingPlanPaypal,
    clearUpdateBillingPlanPaypal,
    userBillingPlanUpdatedPaypal,
    userBillingPlanUpdatedPaypalError,
    disabled,
  } = props;

  useEffect(() => {
    if (userBillingPlanUpdatedPaypal) {
      fetchMe();
      clearUpdateBillingPlanPaypal();
    }
  }, [userBillingPlanUpdatedPaypal]);

  if (disabled) return (
    <Button
      disabled
      className="billing-paypal-button__component"
    >
      <div className="paypal-icon" />
    </Button>
  );

  const proPlan = billingPlans &&
    billingPlans.filter(plan => plan.title === 'Pro')[0];

  return (
    <div className="paypal-button__component">
      <PayPalButton
        style={{
          color: 'blue',
          shape: 'pill',
        }}
        createSubscription={(data, actions) => {
          return actions.subscription.create({
            plan_id: interval === 'month' ? proPlan.paypal_plan_id_monthly
              : proPlan.paypal_plan_id_annual
          });
        }}
        onApprove={data => {
          updateBillingPlanPaypal(data, proPlan.id, interval);
        }}
      />

      {userBillingPlanUpdatedPaypalError &&
        <CommonMessage error>
          Subscription error..
        </CommonMessage>
      }
    </div>
  );
};

PaypalButtonComponent.propTypes = {
  fetchMe: PropTypes.func.isRequired,
  updateBillingPlanPaypal: PropTypes.func.isRequired,
  clearUpdateBillingPlanPaypal: PropTypes.func.isRequired,
  interval: PropTypes.string.isRequired,
  billingPlans: PropTypes.arrayOf(PropTypes.shape),
  userBillingPlanUpdatedPaypal: PropTypes.object,
  userBillingPlanUpdatedPaypalError: PropTypes.object,
  disabled: PropTypes.bool,
};

PaypalButtonComponent.defaultProps = {
  billingPlans: null,
  userBillingPlanUpdatedPaypal: null,
  userBillingPlanUpdatedPaypalError: null,
  disabled: null,
};

const mapStateToProps = state => (
  {
    billingPlans: state.billingReducer.billingPlans,
    userBillingPlanUpdatedPaypal: state.billingReducer.userBillingPlanUpdatedPaypal,
    userBillingPlanUpdatedPaypalError: state.billingReducer.userBillingPlanUpdatedPaypalError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    updateBillingPlanPaypal,
    clearUpdateBillingPlanPaypal,
  },
)(PaypalButtonComponent);
